import { saveAs } from "file-saver";
import JSZip from "jszip";

const safeText = (value) =>
  value === undefined || value === null ? "" : String(value).trim();

const safeFileName = (value, fallback) => {
  const name = safeText(value) || fallback;
  const withoutControlCharacters = Array.from(name)
    .filter((character) => {
      const code = character.charCodeAt(0);
      return code > 31 && code !== 127;
    })
    .join("");
  return withoutControlCharacters.replace(/[<>:"/\\|?*]/g, "_");
};

const safeEntryFileName = (value, fallback) =>
  safeFileName(safeText(value).split(/[\\/]/).pop(), fallback);

export const getAnnualMaskDoctorPackageName = (caseItem = {}) => {
  const caseName =
    safeText(caseItem.batchName) ||
    ["Annual-Mask-Purchase", safeText(caseItem.hn), safeText(caseItem.id)]
      .filter(Boolean)
      .join("-");

  return `${safeFileName(caseName, "Annual-Mask-Purchase")}.zip`;
};

export const downloadAnnualMaskDoctorPackage = async ({
  caseItem = {},
  certificateBlob,
  certificateFileName,
  usageReportBlob,
  usageReportFileName,
  sleepStudyReportBlob,
  sleepStudyReportFileName,
}) => {
  if (!certificateBlob || !usageReportBlob || !sleepStudyReportBlob) {
    throw new Error("The Annual Mask Purchase package is incomplete.");
  }

  const zip = new JSZip();
  zip
    .folder("Annual Mask Medical Certificate")
    .file(
      safeEntryFileName(
        certificateFileName,
        "Annual-Mask-Medical-Certificate.docx",
      ),
      certificateBlob,
    );
  zip
    .folder("CPAP Usage Report")
    .file(
      safeEntryFileName(usageReportFileName, "CPAP-Usage-Report.pdf"),
      usageReportBlob,
    );
  zip
    .folder("Sleep Study Report")
    .file(
      safeEntryFileName(
        sleepStudyReportFileName,
        "Sleep-Study-Report.pdf",
      ),
      sleepStudyReportBlob,
    );

  const zipBlob = await zip.generateAsync({ type: "blob" });
  const zipFileName = getAnnualMaskDoctorPackageName(caseItem);
  saveAs(zipBlob, zipFileName);
  return zipFileName;
};
